export function buildApiBase(configured, environment, origin) {
  const value = typeof configured === 'string' ? configured.trim() : '';
  return (value || (environment === 'production' ? origin : '') || 'http://localhost:5000').replace(/\/+$/, '');
}

export const API_BASE = buildApiBase(
  process.env.REACT_APP_API_URL,
  process.env.NODE_ENV,
  typeof window === 'undefined' ? '' : window.location.origin,
);

export function resolveBackendUrl(value, fallback = '', base = API_BASE) {
  if (typeof value !== 'string' || !value.trim()) return fallback;
  const url = value.trim().replace(/\\/g, '/');
  if (/^(https?:\/\/|\/\/|blob:|data:image\/)/i.test(url)) return url;
  if (/^[a-z][a-z\d+.-]*:/i.test(url)) return fallback;
  return `${base.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`;
}

export function resolveAssetUrl(value, fallback = '', base = API_BASE) {
  if (typeof value !== 'string' || !value.trim()) return fallback;
  const url = value.trim().replace(/\\/g, '/');
  if (/^(https?:\/\/|\/\/|blob:|data:image\/)/i.test(url) || /^[a-z][a-z\d+.-]*:/i.test(url)) {
    return resolveBackendUrl(url, fallback, base);
  }
  const key = url.replace(/^\/+/, '');
  return resolveBackendUrl(key.startsWith('uploads/') ? key : `uploads/${key}`, fallback, base);
}
